import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import App from './App';
import SuperAdminApp from './SuperAdminApp';

// Super Admin is a separate app entirely — different login, different
// session storage key, different theme — not a tab inside the regular
// school admin panel. It's reached either by its own subdomain
// (superadmin.zorvexl.com) or, as a fallback for links/bookmarks made
// before that subdomain existed, the /super-admin path on any host.
const isSuperAdminHost = window.location.hostname.startsWith('superadmin.');
const isSuperAdminPath = window.location.pathname.startsWith('/super-admin');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {(isSuperAdminHost || isSuperAdminPath) ? <SuperAdminApp /> : <App />}
  </React.StrictMode>
);
